export default __webpack_public_path__ + "static/media/aboutDeepak2.351b494c.jpeg";